import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-paper px-8 py-24 sm:px-14 sm:py-32" data-id="element-47" data-mp="e3dh7r4o3cpi">
      <div className="mx-auto max-w-6xl" data-id="element-48" data-mp="9mgn88wz35x">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-49" data-mp="58z4nwbiuga3">
          <div className="lg:col-span-7" data-id="element-50" data-mp="574h0a8v8a2b">
            <p className="font-hand text-3xl leading-none text-pen" data-id="element-51" data-mp="3mgugjv12ehuk">La différence SCIENCES PRÊTES™</p>
            <h2 className="mt-4 font-display text-[2.6rem] leading-[1.02] tracking-tight text-ink sm:text-6xl" data-id="element-52" data-mp="3rgpay8k1tpkd">
              D’un enseignant épuisé à <em className="text-pen" data-id="element-53" data-mp="3diik3cdiopu7">un guide sûr de lui.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-ink/75 lg:col-span-5" data-id="element-54" data-mp="3igakyvw53maj">
            Donnez à vos séances un impact visuel, à vos élèves l’envie de découvrir et à vous-même
            le temps de retrouver le plaisir d’enseigner.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-ink/15 sm:grid-cols-3" data-id="element-55" data-mp="1jadr4yfijbmq">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-56" data-mp="1f929pg6slwpm" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-ink/70" data-id="element-57" data-mp="1o48a1znanmkr">{stat.label}</dt>
              <dd className="font-display text-3xl leading-tight text-ink" data-id="element-58" data-mp="10edxlj6w0011">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-59" data-mp="1ab0ejww3e6xs">
          <article className="rounded-3xl border border-ink/10 bg-paper-deep p-8 sm:p-11" data-id="element-60" data-mp="1a8e7rzh0zvgm">
            <p className="text-sm font-semibold text-ink/60" data-id="element-61" data-mp="15a2zvuaajv11">Avant SCIENCES PRÊTES</p>
            <h3 className="mt-2 font-display text-3xl leading-tight text-ink/80 sm:text-4xl" data-id="element-62" data-mp="2lo2v4ry6ywhy">
              Le coût de l’improvisation
            </h3>
            <ul className="mt-8 divide-y divide-ink/10 border-t border-ink/10" data-id="element-63" data-mp="2orir1p6uxirl">
              {beforeItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-ink/70" data-id="element-64" data-mp="2srsx11ung96g">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-ink/40" aria-hidden="true" data-id="element-65" data-mp="2xsyrb43yk4i3" />
                  {item}
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-ink p-8 text-paper shadow-[0_30px_60px_-30px_rgba(20,32,61,0.6)] sm:p-11" data-id="element-66" data-mp="25419t37kmbqe">
            <p className="text-sm font-semibold text-pen-soft" data-id="element-67" data-mp="2a34hywiuky2l">Avec SCIENCES PRÊTES™</p>
            <h3 className="mt-2 font-display text-3xl leading-tight sm:text-4xl" data-id="element-68" data-mp="2f0ecgql3fzxa">
              Des supports prêts pour passer à l’action
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-69" data-mp="1mcrz4qm2dgx8">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-paper/90" data-id="element-70" data-mp="1rb38z1cczrfg">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-pen" data-id="element-71" data-mp="1jslxipkxa2ju">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-72" data-mp="1eukdo2fo9z7b" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-2xl italic leading-snug text-ink/80 sm:text-3xl" data-id="element-73" data-mp="14x5vnye3p2cw">
          Un pack pour préparer moins et enseigner avec plus de passion.
        </p>
      </div>
    </section>;
}